import { render, staticRenderFns } from "./order-editor.vue?vue&type=template&id=78a66418&scoped=true&"
import script from "./order-editor.vue?vue&type=script&lang=js&"
export * from "./order-editor.vue?vue&type=script&lang=js&"
import style0 from "./order-editor.vue?vue&type=style&index=0&id=78a66418&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a66418",
  null
  
)

export default component.exports